"use strict";

exports.__esModule = true;
exports.ReportListAccordianGridView = ReportListAccordianGridView;
var _react = _interopRequireDefault(require("react"));
var _utils = require("./utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ReportListAccordianGridView(props) {
  var items = props.items,
    thumbnailSize = props.thumbnailSize,
    onItemClick = props.onItemClick,
    selectedIds = props.selectedIds;
  function renderReport(item) {
    if (item) {
      // $FlowFixMe
      if (item.path) {
        // flow can't handle multiple ORs
        return (0, _utils.renderExternalRow)({
          item: item,
          thumbnailSize: thumbnailSize
        });
      }
      return (0, _utils.renderReportListRow)({
        item: item,
        thumbnailSize: thumbnailSize,
        onItemClick: onItemClick,
        selectedIds: selectedIds
      });
    }
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement(_utils.ReportListAccordianGridViewContainer, null, items.map(renderReport));
}